// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_form__gqxEW {}\n\n.styles_header__e-JFz {\n    margin-bottom: 30px;\n}\n\n.styles_column__nIBHR {\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: 1fr 1fr;\n}\n", "",{"version":3,"sources":["webpack://./src/Forms/client-edit-contact-info/styles.module.css"],"names":[],"mappings":"AAAA,qBAAO;;AAEP;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;AAClC","sourcesContent":[".form {}\n\n.header {\n    margin-bottom: 30px;\n}\n\n.column {\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: 1fr 1fr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "styles_form__gqxEW",
	"header": "styles_header__e-JFz",
	"column": "styles_column__nIBHR"
};
export default ___CSS_LOADER_EXPORT___;
